export const setupSwitchService = {
  setMessage(message: string) {
    localStorage.setItem("SetupSwitchMsg", message);
  },
  getMessage() {
    return localStorage.getItem("SetupSwitchMsg");
  },
  clear() {
    localStorage.removeItem("SetupSwitchMsg");
  },
};
